/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAzureSaasUserManagedIndividual extends models.StorageConfigurationBaseForAzureSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAzureSaasUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAzureSaasUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAzureSaasUserManagedIndividual>): StorageConfigurationForAzureSaasUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForAzureSaasUserManagedIndividual(), model);
        StorageConfigurationForAzureSaasUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAzureSaasUserManagedIndividual>): StorageConfigurationForAzureSaasUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForAzureSaasUserManagedIndividual.newInstance(<StorageConfigurationForAzureSaasUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAzureSaasUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForAzureSaasUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAzureSaasUserManagedIndividual): boolean {
        if (models.StorageConfigurationBaseForAzureSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAzureSaasUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
